import React from 'react';
import './TabNav.css';
interface TabNotification {
  tabIndex: number;
  count: number;
}
interface TabNavProps {
  tabs: string[];
  activeTab: number;
  onTabChange: (index: number) => void;
  notifications?: TabNotification[];
  inactiveTabs?: number[];
  inactiveTabsTooltips?: Record<string, string>; // Nouveau: messages pour les onglets inactifs
  disabledTabs?: number[]; // Nouvelle prop
}

const TabNav: React.FC<TabNavProps> = ({
  tabs,
  activeTab,
  onTabChange,
  notifications = [],
  inactiveTabs = [],
  inactiveTabsTooltips = {}, // Par défaut, aucun message personnalisé
  disabledTabs = [],
}) => {
  return (
    <div className="tab-nav">
      {tabs.map((tab, index) => {
        const notification = notifications.find(n => n.tabIndex === index);
        const isInactive = inactiveTabs.includes(index);
        const isDisabled = disabledTabs.includes(index);
        const tooltipMessage = isInactive
          ? (inactiveTabsTooltips[tab] || "Fonctionnalité en cours de développement")
          : isDisabled
          ? "Non disponible dans ce statut"
          : "";

        return (
          <button
            key={index}
            className={`tab-button ${activeTab === index ? 'active' : ''} ${isInactive ? 'inactive' : ''} ${isDisabled ? 'disabled' : ''}`}
            onClick={() => !isInactive && !isDisabled && onTabChange(index)}
            disabled={isInactive || isDisabled}
            title={tooltipMessage}
            data-tooltip={tooltipMessage}
          >
            {tab}
            {notification && notification.count > 0 && (
              <span className="notification-badge">
                {notification.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TabNav;